import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React from "react";

import newSearchIcon from "../../../styles/svg/newSearchIcon.svg";
import SearchBoard from "../../../components/Header/SearchBoard";
import { useAccordionNavState } from "../hooks/useAccordionNavState";
import VirtualizedBoardList from "./VirtualizedBoardList";

const ACCORDION_TRANSITION_PROPS = {
  unmountOnExit: true,
};

function AccordionNav({
  heading,
  icon,
  listing,
  defaultExpanded,
  uniqueKey,
  expanded,
  onChange,
  isBoardSearch,
}) {
  const {
    searchBar,
    setSearchBar,
    handleSearch,
    handleSummaryClick,
  } = useAccordionNavState({
    expanded,
    onChange,
  });
  const renderedListing = React.useMemo(() => {
    if (!listing?.length) {
      return (
        <Typography
          variant="caption"
          gutterBottom
          className="text-center d-flex justify-content-center pl-0 no-margin-left"
        >
          Boards Not Found
        </Typography>
      );
    }

    return (
      <VirtualizedBoardList listing={listing} />
    );
  }, [listing]);

  return (
    <Accordion
      expanded={expanded}
      onChange={() => {}}
      className="menu-Accordion no-box-shadow"
      defaultExpanded={defaultExpanded}
      TransitionProps={ACCORDION_TRANSITION_PROPS}
    >
      <AccordionSummary
        expandIcon={
          isBoardSearch && searchBar.showSearchBar ? (
            ""
          ) : (
            <div style={{ cursor: "pointer" }}>
              <ExpandMoreIcon />
            </div>
          )
        }
        aria-controls="panel1-content"
        id="panel1-header"
        className={`search-board-accordian background-color-0 menu-AccordionSummary`}
        onClick={handleSummaryClick}
      >
        <div className="d-flex align-items-center">
          <img src={icon} alt="Not Found" className="side-bar-icon" />
          <span className="navigation-heading">{heading}</span>
          {isBoardSearch && searchBar.showSearchIcon && (
            <img
              src={newSearchIcon}
              alt="search boards"
              className="ml-1 boards-search-icon"
              onClick={handleSearch}
            />
          )}
        </div>
        {isBoardSearch && searchBar.showSearchBar && (
          <div className="search-board-component">
            <SearchBoard
              isBoardSearch={isBoardSearch}
              setSearchBar={setSearchBar}
            />
          </div>
        )}
      </AccordionSummary>
      <AccordionDetails className="menu-AccordionDetails" key={uniqueKey}>
        {renderedListing}
      </AccordionDetails>
    </Accordion>
  );
}

export default React.memo(AccordionNav);
